import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['modal'];

  connect() {
    console.log('Trail exam quit modal controller connected');
  }

  open(event) {
    console.log('Modal open method called');
    event.preventDefault();
    this.modalTarget.classList.remove('tw-hidden');
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
  }

  close(event) {
    console.log('Modal close method called');
    event.preventDefault();
    this.modalTarget.classList.add('tw-hidden');
    document.body.style.overflow = ''; // Restore scrolling
  }
}
